import { Container, Col, Row, Alert } from "reactstrap";
import { useHistory } from "react-router-dom";

export const CancellableContent = ({ children }) => {
  const history = useHistory();

  return (
    <>
      {children}

      <Container>
        <Row>
          <Col className="text-right">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => history.goBack()}
            >
              Cancel
            </button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
